var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alert alert-danger text-center space-box-alert-custom" },
    [
      _c("p", [_vm._v("無地ダンボール設定の確認が出来ていません。")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("以下の手順を確認して無地ダンボールの設定を行ってください。")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("→"),
        _c(
          "a",
          {
            staticClass: "text--underline",
            attrs: { href: _vm.downloadUrl, target: "_blank" }
          },
          [_c("span", [_vm._v("設定方法")])]
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "※無地のダンボール設定が完了していない場合、他モールで販売が開始されない場合があります。"
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3af0de06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3af0de06","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoDanboard.vue
// module id = null
// module chunks = 